// extracted by mini-css-extract-plugin
export default {"div":"LinesRight_div__ObIhJ"};